module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/364.b423e50a.png";